import { CartItemList } from '@/models/cart/cart-item'
import {
  AllowPurchaseLimitUntilStock,
  AllowPurchaseUntilCartTotalCountLimit,
  AllowPurchaseUntilRestAmountOfPrice,
  AllowPurchaseUntilSkuPurchaseCountLimit,
  PurchaseCountLimitSpecification,
  TotalPurchaseCountWithSameRootMustLessThanRootPurchaseLimit,
  UseClosestRange
} from '@/models/cart/purchase-count/limit/purchase-count-limit-specification'

export class PurchaseCountLimitSpecificationPolicy {
  constructor(
    private readonly wholeCartItems: CartItemList,
    private readonly limitCartUnitCount: number
  ) {}

  get default(): PurchaseCountLimitSpecification {
    return new UseClosestRange([
      new AllowPurchaseLimitUntilStock(),
      new AllowPurchaseUntilSkuPurchaseCountLimit(),
      new TotalPurchaseCountWithSameRootMustLessThanRootPurchaseLimit(this.wholeCartItems),
      new AllowPurchaseUntilRestAmountOfPrice(),
      new AllowPurchaseUntilCartTotalCountLimit(this.wholeCartItems, this.limitCartUnitCount),
    ])
  }
}
